module.exports = __webpack_public_path__ + "media/images/area/feature/kanto/related/zh-hans/6-f06123473752f00e2c22d39ba6d9ab10.jpg";